/**
 * @file Final summary when the export has finished writing to the chosen
 * file. Mirrors export_architecture_v2 §5.7.
 */

import type { ExportProgress } from "../lib/exportRunner";

export function ExportComplete({ progress }: { progress: ExportProgress | null }) {
  return (
    <section style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <h1 style={{ marginTop: 0 }}>エクスポートが完了しました</h1>
      <p style={{ color: "var(--color-text-sub)", lineHeight: 1.7 }}>
        zip ファイルが PC に保存されました。中身の構造については同梱の README.md と schema.md
        を確認してください。
      </p>
      {progress && (
        <ul style={{ paddingLeft: "20px", color: "var(--color-text)" }}>
          <li>ひとコマ: {progress.entriesDone} 件</li>
          <li>気づき: {progress.observationsDone} 件</li>
          <li>通信簿: {progress.digestsDone} 件</li>
          <li>
            メディア: {progress.mediaDone} 件 ({formatBytes(progress.mediaBytes)})
          </li>
        </ul>
      )}
    </section>
  );
}

function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  for (const unit of units) {
    if (value < 1024) return `${value.toFixed(1)} ${unit}`;
    value /= 1024;
  }
  return `${value.toFixed(1)} PB`;
}
